import createCrudVuexModule from "@/store/crud";

export const accessor = createCrudVuexModule({
  namespaced: true,
  path: "/library/accessor",
  moduleName: `accessor`,
});

export const workspaceAccessor = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/accessor",
});

export const managementAccessor = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/accessor",
});
